// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/precautionary-landing-site-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/precautionary-landing-site-procedures/precautionary-landing-site-procedures.js';

mount([g0]);
